module.exports = __webpack_public_path__ + "static/img/druid.09b411e5.svg";